import { InputTypes } from "../InputTypes";

export const SimpleProduct = Object.freeze({
  /*   store_id: {
    visibleName: "ID",
    type: InputTypes.TEXT_AREA,
  }, */
  name: {
    visibleName: "Nombre del producto",
    type: InputTypes.TEXT,
  },
  quantity: {
    visibleName: "Cantidad",
    type: InputTypes.NUMBER,
    min: 0,
  },
  price: {
    visibleName: "Precio",
    type: InputTypes.NUMBER,
    min: 0,
    step: 0.01,
  },
});
